module.exports = __webpack_public_path__ + "static/media/pic.b9e65693.png";